<template>
  <div class="container">
    <head-nav-bar title="会员管理" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav">
      <div class="number-card">
        <div class="title">会员总数</div>
        <div class="number">
          {{ info.MemberTotalCount }}
          <span style="font-size:16px;color:#333;">人</span>
        </div>
      </div>
      <div style="padding:16px;">
        <div class="data-card" style="background:#8BC34A;">
          <van-row>
            <van-col span="11">
              <p style="line-height: 1;">今日充值</p>
              <p class="price">
                {{ info.DayRecharge }} <span style="font-size:16px;">元</span>
              </p>
            </van-col>
            <van-col span="13" class="right">
              <p>本周 {{ info.WeekRecharge }} 元</p>
              <p>本月 {{ info.MonthRecharge }} 元</p>
            </van-col>
          </van-row>
        </div>

        <div class="data-card" style="background:#2196F3;">
          <van-row>
            <van-col span="11">
              <p style="line-height: 1;">今日消费</p>
              <p class="price">
                {{ info.DayConsume }}<span style="font-size:16px;">元</span>
              </p>
            </van-col>
            <van-col span="13" class="right">
              <p>本周 {{ info.WeekConsume }} 元</p>
              <p>本月 {{ info.MonthConsume }} 元</p>
            </van-col>
          </van-row>
        </div>
      </div>
      <van-grid :border="false">
        <van-grid-item
          v-for="(item, index) in list"
          :key="index"
          @click="item.to && routerJump(item.to)"
        >
          <img :src="item.image" width="30" height="30" />
          <div class="title">{{ item.text }}</div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
import { getMemberIndex } from "@/api/member.js";

import { SwipeCell, Button, Row, Col, Grid, GridItem } from "vant";

export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  data() {
    return {
      info: {},
      list: [
        { text: "会员列表", image: "/image/list.png", to: "memberList" },
        { text: "充值", image: "/image/recharge.png", to: "memberRecharge" },
        { text: "消费", image: "/image/consume.png", to: "memberConsume" },
        { text: "新增", image: "/image/add.png", to: "memberAdd" },
        { text: "会员类型", image: "/image/type.png", to: "memberType" },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getMemberIndex({}).then(res => {
        this.info = res.Data;
      });
    },
    routerJump(to) {
      this.$router.push({ name: to });
    },
  },
};
</script>

<style lang="less" scoped>
.number-card {
  padding: 16px;
  .title {
    font-size: 14px;
    color: #999;
  }
  .number {
    font-size: 26px;
    color: red;
    text-align: center;
  }
}
.data-card {
  border-radius: 5px;
  background: #ddd;
  padding: 16px;
  margin-bottom: 6px;
  color: #fff;
  font-size: 14px;
  line-height: 1.6;
  .right {
    border-left: 1px solid #fff;
    padding-left: 16px;
  }
  .price {
    font-size: 20px;
    text-align: center;
  }
}
</style>
